"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quasiquoteExpression = exports.quoteExpression = void 0;
const errors = require("../errors/errors");
const sExpression_1 = require("../sExpression");
const listHelpers_1 = require("../utils/listHelpers");
const interpreter_1 = require("./interpreter");
const util_1 = require("./util");
const value_1 = require("./value");
const quoteLiteral = (literal) => {
    return Object.assign({}, literal);
};
const quoteExpression = (expression, context) => {
    switch (expression.type) {
        case 'boolean':
        case 'number':
        case 'string':
        case 'symbol':
            return quoteLiteral(expression);
        case 'list':
            return value_1.makeList(expression.elements.map(elem => exports.quoteExpression(elem, context)));
        case 'dotted list':
            return value_1.makeImproperList(expression.pre.map(elem => exports.quoteExpression(elem, context)), exports.quoteExpression(expression.post, context));
    }
};
exports.quoteExpression = quoteExpression;
// Handle (quasiquote expr), (unquote expr), and (unquote-splicing expr) specially, if they have not been redefined
function* handleSpecialQuotationForm(expression, context, quoteLevel, unquoteLevel, isUnquoteSplicingAllowed) {
    if (!(expression.elements.length > 1 &&
        expression.elements[0].type === 'symbol' &&
        (expression.elements[0].value === 'quasiquote' ||
            expression.elements[0].value === 'unquote' ||
            expression.elements[0].value === 'unquote-splicing') &&
        !util_1.isDefined(context, expression.elements[0].value))) {
        return null;
    }
    if (expression.elements.length !== 2) {
        return util_1.handleRuntimeError(context, new errors.QuoteSyntaxError(expression.elements[0].value, expression));
    }
    const quoteType = expression.elements[0].value;
    const subExpression = expression.elements[1];
    switch (quoteType) {
        case 'quasiquote': {
            return [
                value_1.makeList([
                    sExpression_1.makeSymbol(quoteType, true),
                    ...(yield* quasiquoteExpressionInner(subExpression, context, quoteLevel + 1, unquoteLevel, true))
                ])
            ];
        }
        case 'unquote': {
            if (quoteLevel === unquoteLevel) {
                return [yield* interpreter_1.evaluate(subExpression, context)];
            }
            else if (quoteLevel > unquoteLevel) {
                return [
                    value_1.makeList([
                        sExpression_1.makeSymbol(quoteType, true),
                        ...(yield* quasiquoteExpressionInner(subExpression, context, quoteLevel, unquoteLevel + 1, true))
                    ])
                ];
            }
            else {
                return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('invalid quasiquotation depth'));
            }
        }
        case 'unquote-splicing': {
            if (!isUnquoteSplicingAllowed) {
                return util_1.handleRuntimeError(context, new errors.UnquoteSplicingInNonListContext(expression));
            }
            if (quoteLevel === unquoteLevel) {
                const unquoted = yield* interpreter_1.evaluate(subExpression, context);
                if (unquoted.type === 'empty list') {
                    return [];
                }
                if (unquoted.type !== 'pair') {
                    return util_1.handleRuntimeError(context, new errors.UnquoteSplicingEvaluatedToNonList(unquoted, expression));
                }
                const list = listHelpers_1.flattenPairToList(unquoted);
                if (list.type !== 'List') {
                    return util_1.handleRuntimeError(context, new errors.UnquoteSplicingEvaluatedToNonList(unquoted, expression));
                }
                return list.value.map(element => element.value);
            }
            else if (quoteLevel > unquoteLevel) {
                return [
                    value_1.makeList([
                        sExpression_1.makeSymbol(quoteType, true),
                        ...(yield* quasiquoteExpressionInner(subExpression, context, quoteLevel, unquoteLevel + 1, true))
                    ])
                ];
            }
            else {
                return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('invalid quasiquotation depth'));
            }
        }
    }
}
function* quasiquoteExpression(expression, context) {
    const quoted = yield* quasiquoteExpressionInner(expression, context, 1, 1, false);
    if (quoted.length !== 1) {
        return util_1.handleRuntimeError(context, new errors.UnreachableCodeReached('top-level quasiquote should return a single value'));
    }
    return quoted[0];
}
exports.quasiquoteExpression = quasiquoteExpression;
function* quasiquoteExpressionInner(expression, context, quoteLevel, unquoteLevel, isUnquoteSplicingAllowed) {
    switch (expression.type) {
        case 'boolean':
        case 'number':
        case 'string':
        case 'symbol':
            return [quoteLiteral(expression)];
        case 'list': {
            // Handle special forms, i.e., (quasiquote expr), (unquote expr), and (unquote-splicing expr)
            const maybeHandledAsSpecialForm = yield* handleSpecialQuotationForm(expression, context, quoteLevel, unquoteLevel, isUnquoteSplicingAllowed);
            if (maybeHandledAsSpecialForm) {
                return maybeHandledAsSpecialForm;
            }
            // Handle as a normal list
            const quoted = [];
            for (const element of expression.elements) {
                // Allow unquote-splicing and spread each result
                quoted.push(...(yield* quasiquoteExpressionInner(element, context, quoteLevel, unquoteLevel, true)));
            }
            return [value_1.makeList(quoted)];
        }
        case 'dotted list': {
            const beforeDot = [];
            for (const element of expression.pre) {
                // Allow unquote-splicing and spread each result
                beforeDot.push(...(yield* quasiquoteExpressionInner(element, context, quoteLevel, unquoteLevel, true)));
            }
            // Do not allow splicing unquote at the tail
            const afterDot = (yield* quasiquoteExpressionInner(expression.post, context, quoteLevel, unquoteLevel, false))[0];
            return [value_1.makeImproperList(beforeDot, afterDot)];
        }
    }
}
//# sourceMappingURL=quote.js.map